var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "router-link",
            {
              staticClass: "small text-primary bold btn-view-app",
              attrs: { to: _vm.href },
            },
            [
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("application.applicationID")) +
                    ": " +
                    _vm._s(_vm.applicationId) +
                    "\n        "
                ),
                _vm.filogixId
                  ? _c("span", { staticClass: "ml-1" }, [
                      _vm._v("(" + _vm._s(_vm.filogixId) + ")"),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: { title: _vm.getTooltipTitle },
                  expression: "{ title: getTooltipTitle }",
                },
              ],
              staticClass: "clickable mx-1",
              class: {
                pinned: _vm.isApplicationPinned,
                "pin-app": !_vm.disablePinApplication,
              },
            },
            [
              _c("icon", {
                class: { disabled: _vm.disablePinApplication },
                attrs: { name: "thumb-tack", "aria-hidden": "true" },
                on: { click: _vm.pinApplication },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.allowDelete
            ? [
                _vm.deletingApplication[_vm.applicationId]
                  ? _c("span", [
                      _c("i", {
                        staticClass:
                          "fa fa-circle-o-notch fa-spin text-danger ml-2",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ])
                  : _c("inline-prompt", {
                      staticClass: "d-inline-block ml-2 delete-application",
                      attrs: {
                        disabled: _vm.isViewOnly,
                        "confirmation-text":
                          _vm.$t("global.messages.allDataWillBeLost") + ": ",
                      },
                      on: {
                        accept: function ($event) {
                          return _vm.removeApplication(_vm.applicationId)
                        },
                      },
                    }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("p", { staticClass: "small text-gray mb-0 regular-line-height" }, [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$t("tables.columns.createdOn")) + ": "),
          ]),
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("formatDateHour")(_vm.createdAt)) +
              "\n      "
          ),
          _c("span", { staticClass: "small text-capitalize" }, [
            _vm._v(
              "\n        (" +
                _vm._s(_vm._f("formatTimeAgo")(_vm.createdAt)) +
                ")\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("p", { staticClass: "small text-gray mb-0 regular-line-height" }, [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$tc("global.words.address", 1)) + ":"),
          ]),
          _vm._v("\n      " + _vm._s(_vm.propertyAddress) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("p", { staticClass: "small text-gray mb-0 regular-line-height" }, [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$t("global.doorr.mortgageAmount")) + ":"),
          ]),
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("formatMoneyValueLong")(_vm.localMortgageAmount)) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("p", { staticClass: "small text-gray mb-0 regular-line-height" }, [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$t("application.coapps")) + ":"),
          ]),
          _vm._v("\n      " + _vm._s(_vm.coapps) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "inline-prompt",
            {
              staticClass: "d-inline-block",
              attrs: {
                disabled: _vm.isViewOnly,
                "confirmation-text": _vm.$t("messages.confirmCopyApplication"),
                placement: "right",
              },
              on: { accept: _vm.copyApplication },
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "clickable text-primary bold copy-client small regular-line-height",
                  class: { disabled: _vm.isViewOnly },
                },
                [
                  _vm._v(
                    "+ " + _vm._s(_vm.$t("application.listing.copyApplication"))
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "mt-2 text-right", attrs: { cols: "12" } },
        [
          _c(
            "router-link",
            {
              staticClass: "btn bold btn-white btn-sm",
              attrs: { to: _vm.href },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application.actions.openApplication")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value:
                    "duplicate-client-profile-modal-" + _vm.clientProfileId,
                  expression:
                    "`duplicate-client-profile-modal-${clientProfileId}`",
                },
              ],
              staticClass: "btn bold btn-white btn-sm",
              attrs: { disabled: _vm.isViewOnly },
              on: { click: _vm.handleOpenDuplicateModal },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("client-profile.actions.createNewProfile")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }